import { isAxiosError } from "axios";
import { useState } from "react";
import { api } from "../../utils/api";

interface QRCodeData {
  qrCode: string;
  secretCode: string;
}

export const useUpdateQRCodeValidation = (token: string | null, id: string | null) => {
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const [qrCode, setQrCode] = useState<QRCodeData | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const updateQRCodeValidation = async (code: string) => {
        if (!token) return;

        setLoading(true);
        setError(null);
    
        try {
            const res = await api.post(
                `/auth-users-task/main-info-update-2fa-code/${id}`,
                { code },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            console.log(res.data);
            setQrCode(res.data.authQRCodeUpdate)
            setIsValid(true);
        } catch (err) {
            if (isAxiosError(err)) {
                const backendError =
                err.response?.data?.errors?.code || // <-- ось правильний шлях
                err.response?.data?.message ||      // запасний варіант
                err.message;

                console.error("Validation error:", backendError);
                setError(backendError);
            } else if (err instanceof Error) {
                setError(err.message);
            } else {
                setError("Unknown error");
            }

            setIsValid(false);
        }
    };
    
    return { updateQRCodeValidation, qrCode, loading, error, isValid };
}